<div class="myPurchase-dialog-container">
  <div class="myPurchase-dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    Upload template
  </div>
  <div class="myPurchase-dialog-content">
    <div class="center">
      <ngx-file-drop dropZoneLabel="Drag and drop files here" (onFileDrop)="dropped($event)"
        accept=".pdf, .doc, .docx, .xls, .xlsx, .tiff, .gif, .jpg, .bmp, .png, .txt, .cad, .dwg" [directory]="false"
        dropZoneClassName="file-upload-dropzone">
        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
          <a (click)="openFileSelector()">
            <div class="file-selector-content">
              <p class="file-text">
                <mat-icon>cloud_upload</mat-icon>
                <span>
                  <span class="emp-text">Choose a file</span>
                  <span class="to-upload"> to upload</span>
                </span>
              </p>
              <p class="helper-file-text">or drag and drop it here</p>
              <p class="file-hint">
                Max file size 50MB. Format allowed: xlsx
              </p>
            </div>
          </a>
        </ng-template>
      </ngx-file-drop>
    </div>
    <div class="file-info">
      <div class="file-name-input">
        <p class="file-name-label">File name:</p>
        <p *ngIf="!fileName" class="file-name-value">No file chosen</p>
        <p *ngIf="fileName" class="file-name-value"><span>{{fileName}}</span>
          <button mat-icon-button (click)="removeFile()" [disabled]="uploadingInProgress">
            <mat-icon>close</mat-icon>
          </button>
        </p>
      </div>
      <div class="form-inputs">
        <p>Status:</p>
        <div class="message-container">
          <div *ngIf="uploadingInProgress">Initialising upload, please wait and do not close this window ...</div>
          <div *ngIf="showErrorMessage" class="myPurchase-error-msg">{{errorMsg}}</div>
          <div *ngIf="error" class="status-message">
            <span class="myPurchase-error-msg">Upload failed: {{fileName}}<br /></span>
            <span class="myPurchase-error-msg">Please review the errors below and try again.<br /></span>
            <span>{{error}}</span>
          </div>
          <div *ngIf="success" class="status-message">
            <span class="myPurchase-success-msg" [innerHTML]="success"><br /></span>
            <span>You may upload another file or close this window</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="myPurchase-dialog-actions">
    <div mat-dialog-actions>
      <app-button class="padBtn" name="Cancel" mat-dialog-close></app-button>
      <app-button *ngIf="!uploadingInProgress" class="padBtn actionBtn" name="Upload" type="flat-button"
        (click)="uploadFile()"></app-button>
      <app-button class="padBtn" *ngIf="uploadingInProgress" [disabled]="true" name="Uploading"></app-button>
    </div>
  </div>
</div>